import { TranslocoPipe } from '@jsverse/transloco';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MatBadgeModule } from '@angular/material/badge';
import { ButtonComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-clear-filter-badge',
    imports: [TranslocoPipe, MatBadgeModule, ButtonComponent],
    templateUrl: './clear-filter-badge.component.html',
    styleUrls: ['./clear-filter-badge.component.scss'],
})
export class ClearFilterBadgeComponent {
    @Input()
    filterCount: number = 0;

    /** Event is fired when Clear filters action button is clicked */
    @Output()
    clearFilters = new EventEmitter();
}
